<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<h2 mat-dialog-title class="bgDialogHeader text-center">Invoice
  <div class="pull-right">
    <a class="boxclose" (click)="onNoClick()"></a>
  </div>
</h2>
<mat-dialog-content class="mat-typography">
  <nb-card>
    <nb-card-body>
      <div class="col-md-9" id="print-section">
        <iframe id="invoiceIframe" width="1000" height="3500" [src]="invoiceUrl" allowfullscreen></iframe>
      </div>
      <div class="col-md-3">
        <form [formGroup]="woInvoiceDetails">
          <div class="row">
            <div class="col-md-12">
              <mat-form-field>
                <input type="text" class="w-100" placeholder="Reference Number" matInput formControlName="ref_no">
              </mat-form-field>
              <mat-form-field>
                <input type="text" class="w-100" placeholder="PO Number" matInput formControlName="po_number">
              </mat-form-field>
              <mat-form-field>
                <input type="text" class="w-100" placeholder="Truck Number" matInput formControlName="truck_number">
              </mat-form-field>
              <mat-form-field>
                <input type="text" class="w-100" placeholder="Trailer Number" matInput formControlName="trailer_number">
              </mat-form-field>
              <mat-form-field>
                <input type="text" class="w-100" placeholder="Odometer" matInput formControlName="odometer">
              </mat-form-field>
            </div>
          </div>
        </form>
      </div>
    </nb-card-body>
  </nb-card>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button title="Print" class="btn btn-success btn-semi-round btn-demo bgBlue pull-right mr-2"
    printSectionId="print-section" ngxPrint> Print </button>
  <button (click)="updateWODetails()" class="btn btn-success btn-semi-round btn-demo bgBlue pull-right mr-2"> Update
  </button>
  <button (click)="onNoClick()" class="btn btn-success btn-semi-round btn-demo bgBlue pull-right"> Close </button>
</mat-dialog-actions>